export default __webpack_public_path__ + "static/media/alert-icon-7.e58af782.svg";